//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AssetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    updateAsset(customerId: string, request: UpdateAssetDto | undefined , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateAsset(_response);
        });
    }

    protected processUpdateAsset(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAssets(customerId: string, searchTerm: string | null, excludedPlaylistId: string | null | undefined, fileTypes: string[] | undefined, fileCodecs: string[] | undefined, aspectRatios: string[] | undefined, resolution: string[] | undefined, tags: string[] | undefined, sort: AssetSort | null, pageNumber: number | null , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfAssetListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (searchTerm === undefined)
            throw new Error("The parameter 'searchTerm' must be defined.");
        else if(searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (excludedPlaylistId !== undefined && excludedPlaylistId !== null)
            url_ += "excludedPlaylistId=" + encodeURIComponent("" + excludedPlaylistId) + "&";
        if (fileTypes === null)
            throw new Error("The parameter 'fileTypes' cannot be null.");
        else if (fileTypes !== undefined)
            fileTypes && fileTypes.forEach(item => { url_ += "fileTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fileCodecs === null)
            throw new Error("The parameter 'fileCodecs' cannot be null.");
        else if (fileCodecs !== undefined)
            fileCodecs && fileCodecs.forEach(item => { url_ += "fileCodecs=" + encodeURIComponent("" + item) + "&"; });
        if (aspectRatios === null)
            throw new Error("The parameter 'aspectRatios' cannot be null.");
        else if (aspectRatios !== undefined)
            aspectRatios && aspectRatios.forEach(item => { url_ += "aspectRatios=" + encodeURIComponent("" + item) + "&"; });
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            resolution && resolution.forEach(item => { url_ += "resolution=" + encodeURIComponent("" + item) + "&"; });
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (sort === undefined)
            throw new Error("The parameter 'sort' must be defined.");
        else if(sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        if (pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' must be defined.");
        else if(pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssets(_response);
        });
    }

    protected processGetAssets(response: AxiosResponse): Promise<PagedServerResponseOfAssetListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedServerResponseOfAssetListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<PagedServerResponseOfAssetListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfAssetListDto | null>(null as any);
    }

    deleteAsset(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfAssetDetailDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAsset(_response);
        });
    }

    protected processDeleteAsset(response: AxiosResponse): Promise<ServerResponseOfAssetDetailDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfAssetDetailDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfAssetDetailDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfAssetDetailDto | null>(null as any);
    }

    getPlaylistsAssets(customerId: string, playlistId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfAssetPlaylistListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/playlist/{playlistId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaylistsAssets(_response);
        });
    }

    protected processGetPlaylistsAssets(response: AxiosResponse): Promise<ServerResponseOfListOfAssetPlaylistListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfAssetPlaylistListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfAssetPlaylistListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfAssetPlaylistListDto | null>(null as any);
    }

    getAssetsIds(customerId: string, searchTerm: string | null, excludedPlaylistId: string | null | undefined, fileTypes: string[] | undefined, fileCodecs: string[] | undefined, aspectRatios: string[] | undefined, resolution: string[] | undefined, tags: string[] | undefined, sort: AssetSort | null , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfString | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/ids?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (searchTerm === undefined)
            throw new Error("The parameter 'searchTerm' must be defined.");
        else if(searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (excludedPlaylistId !== undefined && excludedPlaylistId !== null)
            url_ += "excludedPlaylistId=" + encodeURIComponent("" + excludedPlaylistId) + "&";
        if (fileTypes === null)
            throw new Error("The parameter 'fileTypes' cannot be null.");
        else if (fileTypes !== undefined)
            fileTypes && fileTypes.forEach(item => { url_ += "fileTypes=" + encodeURIComponent("" + item) + "&"; });
        if (fileCodecs === null)
            throw new Error("The parameter 'fileCodecs' cannot be null.");
        else if (fileCodecs !== undefined)
            fileCodecs && fileCodecs.forEach(item => { url_ += "fileCodecs=" + encodeURIComponent("" + item) + "&"; });
        if (aspectRatios === null)
            throw new Error("The parameter 'aspectRatios' cannot be null.");
        else if (aspectRatios !== undefined)
            aspectRatios && aspectRatios.forEach(item => { url_ += "aspectRatios=" + encodeURIComponent("" + item) + "&"; });
        if (resolution === null)
            throw new Error("The parameter 'resolution' cannot be null.");
        else if (resolution !== undefined)
            resolution && resolution.forEach(item => { url_ += "resolution=" + encodeURIComponent("" + item) + "&"; });
        if (tags === null)
            throw new Error("The parameter 'tags' cannot be null.");
        else if (tags !== undefined)
            tags && tags.forEach(item => { url_ += "tags=" + encodeURIComponent("" + item) + "&"; });
        if (sort === undefined)
            throw new Error("The parameter 'sort' must be defined.");
        else if(sort !== null)
            url_ += "sort=" + encodeURIComponent("" + sort) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsIds(_response);
        });
    }

    protected processGetAssetsIds(response: AxiosResponse): Promise<ServerResponseOfListOfString | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfString.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfString | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfString | null>(null as any);
    }

    getAssetDetail(customerId: string, assetId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfAssetDetailDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/{assetId}/detail";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetDetail(_response);
        });
    }

    protected processGetAssetDetail(response: AxiosResponse): Promise<ServerResponseOfAssetDetailDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfAssetDetailDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfAssetDetailDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfAssetDetailDto | null>(null as any);
    }

    getAssetUploadStatusDetail(customerId: string, assetId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfAssetUploadStatus | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/{assetId}/uploadstatus";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetUploadStatusDetail(_response);
        });
    }

    protected processGetAssetUploadStatusDetail(response: AxiosResponse): Promise<ServerResponseOfListOfAssetUploadStatus | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfAssetUploadStatus.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfAssetUploadStatus | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfAssetUploadStatus | null>(null as any);
    }

    getAssetData(customerId: string, thumbnailImage: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/thumbnail/{thumbnailImage}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (thumbnailImage === undefined || thumbnailImage === null)
            throw new Error("The parameter 'thumbnailImage' must be defined.");
        url_ = url_.replace("{thumbnailImage}", encodeURIComponent("" + thumbnailImage));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetData(_response);
        });
    }

    protected processGetAssetData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAssetResourceDataUrl(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<AssetResourceDataDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/{id}/resource";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetResourceDataUrl(_response);
        });
    }

    protected processGetAssetResourceDataUrl(response: AxiosResponse): Promise<AssetResourceDataDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? AssetResourceDataDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<AssetResourceDataDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetResourceDataDto | null>(null as any);
    }

    getDownloadAssetDataUrl(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<string | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/{id}/download";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDownloadAssetDataUrl(_response);
        });
    }

    protected processGetDownloadAssetDataUrl(response: AxiosResponse): Promise<string | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string | null>(null as any);
    }

    getAssetFilterOptions(customerId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfAssetFilterOptions | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/filterOptions";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetFilterOptions(_response);
        });
    }

    protected processGetAssetFilterOptions(response: AxiosResponse): Promise<ServerResponseOfAssetFilterOptions | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfAssetFilterOptions.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfAssetFilterOptions | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfAssetFilterOptions | null>(null as any);
    }

    gatAssetTags(customerId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfString | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/tags";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGatAssetTags(_response);
        });
    }

    protected processGatAssetTags(response: AxiosResponse): Promise<ServerResponseOfListOfString | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfString.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfString | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfString | null>(null as any);
    }

    previewAsset(customerId: string, previewRequest: AssetPreviewRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/preview";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(previewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewAsset(_response);
        });
    }

    protected processPreviewAsset(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    previewAssetStop(customerId: string, stopPreviewRequest: AssetPreviewStopRequest | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Assets/preview/stop";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(stopPreviewRequest);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreviewAssetStop(_response);
        });
    }

    protected processPreviewAssetStop(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getPandorasBoxLogo(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/christielogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPandorasBoxLogo(_response);
        });
    }

    protected processGetPandorasBoxLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AuditLogsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAssetsAuditLogs(customerId: string, assetId: string, lastAuditLogDate: Date | null , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfAuditLogDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/AuditLogs/{assetId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        if (lastAuditLogDate === undefined)
            throw new Error("The parameter 'lastAuditLogDate' must be defined.");
        else if(lastAuditLogDate !== null)
            url_ += "lastAuditLogDate=" + encodeURIComponent(lastAuditLogDate ? "" + lastAuditLogDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsAuditLogs(_response);
        });
    }

    protected processGetAssetsAuditLogs(response: AxiosResponse): Promise<ServerResponseOfListOfAuditLogDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfAuditLogDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfAuditLogDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfAuditLogDto | null>(null as any);
    }
}

export class AuthorizationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    exchange(  cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/connect/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExchange(_response);
        });
    }

    protected processExchange(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CanvasesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createCanvas(customerId: string, request: CreateCanvasDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseWithId | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCanvas(_response);
        });
    }

    protected processCreateCanvas(response: AxiosResponse): Promise<ServerResponseWithId | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseWithId.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseWithId | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseWithId | null>(null as any);
    }

    updateCanvas(customerId: string, request: UpdateCanvasDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfCanvasListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCanvas(_response);
        });
    }

    protected processUpdateCanvas(response: AxiosResponse): Promise<ServerResponseOfCanvasListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfCanvasListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfCanvasListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfCanvasListDto | null>(null as any);
    }

    getCanvases(customerId: string, pageNumber: number | null , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfCanvasListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' must be defined.");
        else if(pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCanvases(_response);
        });
    }

    protected processGetCanvases(response: AxiosResponse): Promise<PagedServerResponseOfCanvasListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedServerResponseOfCanvasListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<PagedServerResponseOfCanvasListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfCanvasListDto | null>(null as any);
    }

    deleteCanvas(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCanvas(_response);
        });
    }

    protected processDeleteCanvas(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getCanvasById(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfCanvasListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCanvasById(_response);
        });
    }

    protected processGetCanvasById(response: AxiosResponse): Promise<ServerResponseOfCanvasListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfCanvasListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfCanvasListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfCanvasListDto | null>(null as any);
    }

    getAllCanvases(customerId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfCanvasBasicDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases/all";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCanvases(_response);
        });
    }

    protected processGetAllCanvases(response: AxiosResponse): Promise<ServerResponseOfListOfCanvasBasicDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfCanvasBasicDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfCanvasBasicDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfCanvasBasicDto | null>(null as any);
    }

    getAssetsCanvases(customerId: string, assetId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfCanvasBasicDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Canvases/asset/{assetId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsCanvases(_response);
        });
    }

    protected processGetAssetsCanvases(response: AxiosResponse): Promise<ServerResponseOfListOfCanvasBasicDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfCanvasBasicDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfCanvasBasicDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfCanvasBasicDto | null>(null as any);
    }
}

export class ConnectedDevicesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createConnectedDevice(customerId: string, request: CreateConnectedDeviceDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseWithId | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/ConnectedDevices";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateConnectedDevice(_response);
        });
    }

    protected processCreateConnectedDevice(response: AxiosResponse): Promise<ServerResponseWithId | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseWithId.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseWithId | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseWithId | null>(null as any);
    }

    getConnectedDevices(customerId: string, pageNumber: number | null , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfConnectedDeviceListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/ConnectedDevices?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' must be defined.");
        else if(pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectedDevices(_response);
        });
    }

    protected processGetConnectedDevices(response: AxiosResponse): Promise<PagedServerResponseOfConnectedDeviceListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedServerResponseOfConnectedDeviceListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<PagedServerResponseOfConnectedDeviceListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfConnectedDeviceListDto | null>(null as any);
    }

    updateConnectedDevice(request: UpdateConnectedDeviceDto | undefined , cancelToken?: CancelToken | undefined): Promise<ConnectedDeviceListDto | null> {
        let url_ = this.baseUrl + "/api/ConnectedDevices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateConnectedDevice(_response);
        });
    }

    protected processUpdateConnectedDevice(response: AxiosResponse): Promise<ConnectedDeviceListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ConnectedDeviceListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ConnectedDeviceListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConnectedDeviceListDto | null>(null as any);
    }

    deleteConnectedDevice(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/ConnectedDevices/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteConnectedDevice(_response);
        });
    }

    protected processDeleteConnectedDevice(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getConnectedDeviceById(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfConnectedDeviceListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/ConnectedDevices/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectedDeviceById(_response);
        });
    }

    protected processGetConnectedDeviceById(response: AxiosResponse): Promise<ServerResponseOfConnectedDeviceListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfConnectedDeviceListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfConnectedDeviceListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfConnectedDeviceListDto | null>(null as any);
    }

    getConnectedDeviceByRegisterationCode(registerationcode: string , cancelToken?: CancelToken | undefined): Promise<ConnectedDeviceDetailDto | null> {
        let url_ = this.baseUrl + "/api/ConnectedDevices/{registerationcode}/registerationcode";
        if (registerationcode === undefined || registerationcode === null)
            throw new Error("The parameter 'registerationcode' must be defined.");
        url_ = url_.replace("{registerationcode}", encodeURIComponent("" + registerationcode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetConnectedDeviceByRegisterationCode(_response);
        });
    }

    protected processGetConnectedDeviceByRegisterationCode(response: AxiosResponse): Promise<ConnectedDeviceDetailDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ConnectedDeviceDetailDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ConnectedDeviceDetailDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConnectedDeviceDetailDto | null>(null as any);
    }
}

export class CustomersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createCustomer(request: CreateCustomerDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseWithId | null> {
        let url_ = this.baseUrl + "/api/Customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (request === null || request === undefined)
            throw new Error("The parameter 'request' cannot be null.");
        else
            content_.append("request", JSON.stringify(request));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCustomer(_response);
        });
    }

    protected processCreateCustomer(response: AxiosResponse): Promise<ServerResponseWithId | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseWithId.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseWithId | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseWithId | null>(null as any);
    }

    updateCustomer(request: UpdateCustomerDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfCustomerListDto | null> {
        let url_ = this.baseUrl + "/api/Customers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (request === null || request === undefined)
            throw new Error("The parameter 'request' cannot be null.");
        else
            content_.append("request", JSON.stringify(request));

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomer(_response);
        });
    }

    protected processUpdateCustomer(response: AxiosResponse): Promise<ServerResponseOfCustomerListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfCustomerListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfCustomerListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfCustomerListDto | null>(null as any);
    }

    getCustomers(pageNumber: number | null, status: CustomerStatus | null | undefined, searchTerm: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfCustomerListDto | null> {
        let url_ = this.baseUrl + "/api/Customers?";
        if (pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' must be defined.");
        else if(pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (status !== undefined && status !== null)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomers(_response);
        });
    }

    protected processGetCustomers(response: AxiosResponse): Promise<PagedServerResponseOfCustomerListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedServerResponseOfCustomerListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<PagedServerResponseOfCustomerListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfCustomerListDto | null>(null as any);
    }

    createCustomerWithoutLogo(request: CreateCustomerDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseWithId | null> {
        let url_ = this.baseUrl + "/api/Customers/simple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateCustomerWithoutLogo(_response);
        });
    }

    protected processCreateCustomerWithoutLogo(response: AxiosResponse): Promise<ServerResponseWithId | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseWithId.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseWithId | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseWithId | null>(null as any);
    }

    updateCustomerWithoutLogo(request: UpdateCustomerDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfCustomerListDto | null> {
        let url_ = this.baseUrl + "/api/Customers/simple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCustomerWithoutLogo(_response);
        });
    }

    protected processUpdateCustomerWithoutLogo(response: AxiosResponse): Promise<ServerResponseOfCustomerListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfCustomerListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfCustomerListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfCustomerListDto | null>(null as any);
    }

    deleteCustomer(id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteCustomer(_response);
        });
    }

    protected processDeleteCustomer(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getCustomerInfo(id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfCustomerListDto | null> {
        let url_ = this.baseUrl + "/api/Customers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerInfo(_response);
        });
    }

    protected processGetCustomerInfo(response: AxiosResponse): Promise<ServerResponseOfCustomerListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfCustomerListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfCustomerListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfCustomerListDto | null>(null as any);
    }

    archiveCustomer(id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Customers/{id}/archive";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveCustomer(_response);
        });
    }

    protected processArchiveCustomer(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    activateCustomer(id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Customers/{id}/activate";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PATCH",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateCustomer(_response);
        });
    }

    protected processActivateCustomer(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getTimeZones(  cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfSelectListDto | null> {
        let url_ = this.baseUrl + "/api/Customers/timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeZones(_response);
        });
    }

    protected processGetTimeZones(response: AxiosResponse): Promise<ServerResponseOfListOfSelectListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfSelectListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfSelectListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfSelectListDto | null>(null as any);
    }

    getCustomerLogo(id: string , cancelToken?: CancelToken | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Customers/{id}/logo";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerLogo(_response);
        });
    }

    protected processGetCustomerLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllCustomerNames(  cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfString | null> {
        let url_ = this.baseUrl + "/api/Customers/names";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllCustomerNames(_response);
        });
    }

    protected processGetAllCustomerNames(response: AxiosResponse): Promise<ServerResponseOfListOfString | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfString.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfString | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfString | null>(null as any);
    }

    getCustomerTotalFileSizeUsed(id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfDouble | null> {
        let url_ = this.baseUrl + "/api/Customers/{id}/fileusage";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerTotalFileSizeUsed(_response);
        });
    }

    protected processGetCustomerTotalFileSizeUsed(response: AxiosResponse): Promise<ServerResponseOfDouble | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfDouble.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfDouble | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfDouble | null>(null as any);
    }
}

export class PlaylistsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createPlaylist(customerId: string, request: CreatePlaylistDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseWithId | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePlaylist(_response);
        });
    }

    protected processCreatePlaylist(response: AxiosResponse): Promise<ServerResponseWithId | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseWithId.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseWithId | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseWithId | null>(null as any);
    }

    updatePlaylist(customerId: string, request: UpdatePlaylistDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdatePlaylist(_response);
        });
    }

    protected processUpdatePlaylist(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getPlaylists(customerId: string, searchTerm: string | null, pageNumber: number | null , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfPlaylistListDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (searchTerm === undefined)
            throw new Error("The parameter 'searchTerm' must be defined.");
        else if(searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' must be defined.");
        else if(pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaylists(_response);
        });
    }

    protected processGetPlaylists(response: AxiosResponse): Promise<PagedServerResponseOfPlaylistListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedServerResponseOfPlaylistListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<PagedServerResponseOfPlaylistListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfPlaylistListDto | null>(null as any);
    }

    deletePlaylist(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlaylist(_response);
        });
    }

    protected processDeletePlaylist(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getPlaylistById(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfPlaylistDetailDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaylistById(_response);
        });
    }

    protected processGetPlaylistById(response: AxiosResponse): Promise<ServerResponseOfPlaylistDetailDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfPlaylistDetailDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfPlaylistDetailDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfPlaylistDetailDto | null>(null as any);
    }

    deletePlaylistsAsset(customerId: string, id: string, assetPlaylistId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists/{id}/assets/{assetPlaylistId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (assetPlaylistId === undefined || assetPlaylistId === null)
            throw new Error("The parameter 'assetPlaylistId' must be defined.");
        url_ = url_.replace("{assetPlaylistId}", encodeURIComponent("" + assetPlaylistId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlaylistsAsset(_response);
        });
    }

    protected processDeletePlaylistsAsset(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getAllPlaylists(customerId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfPlaylistBasicDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists/all";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllPlaylists(_response);
        });
    }

    protected processGetAllPlaylists(response: AxiosResponse): Promise<ServerResponseOfListOfPlaylistBasicDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfPlaylistBasicDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfPlaylistBasicDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfPlaylistBasicDto | null>(null as any);
    }

    getPlaylistFullDetailById(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfPlaylistFullDetailDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists/{id}/full";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaylistFullDetailById(_response);
        });
    }

    protected processGetPlaylistFullDetailById(response: AxiosResponse): Promise<ServerResponseOfPlaylistFullDetailDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfPlaylistFullDetailDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfPlaylistFullDetailDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfPlaylistFullDetailDto | null>(null as any);
    }

    getAssetsPlaylists(customerId: string, assetId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfPlaylistBasicDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Playlists/asset/{assetId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssetsPlaylists(_response);
        });
    }

    protected processGetAssetsPlaylists(response: AxiosResponse): Promise<ServerResponseOfListOfPlaylistBasicDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfPlaylistBasicDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfPlaylistBasicDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfPlaylistBasicDto | null>(null as any);
    }
}

export class SchedulesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createSchedule(customerId: string, request: CreateScheduleDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseWithId | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Schedules";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSchedule(_response);
        });
    }

    protected processCreateSchedule(response: AxiosResponse): Promise<ServerResponseWithId | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseWithId.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseWithId | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseWithId | null>(null as any);
    }

    updateSchedule(customerId: string, request: UpdateScheduleDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Schedules";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSchedule(_response);
        });
    }

    protected processUpdateSchedule(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getSchedules(customerId: string, startDate: Date, endDate: Date , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfSchedulesWithCanvases | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Schedules?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSchedules(_response);
        });
    }

    protected processGetSchedules(response: AxiosResponse): Promise<ServerResponseOfSchedulesWithCanvases | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfSchedulesWithCanvases.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfSchedulesWithCanvases | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfSchedulesWithCanvases | null>(null as any);
    }

    deleteSchedule(customerId: string, id: string , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Schedules/{id}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteSchedule(_response);
        });
    }

    protected processDeleteSchedule(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getPlaylistsSchedules(customerId: string, playlistId: string, startDate: Date, pageSizeLimit: number , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfListOfPlaylistScheduleDto | null> {
        let url_ = this.baseUrl + "/api/customer/{customerId}/Schedules/playlist/{playlistId}?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (playlistId === undefined || playlistId === null)
            throw new Error("The parameter 'playlistId' must be defined.");
        url_ = url_.replace("{playlistId}", encodeURIComponent("" + playlistId));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (pageSizeLimit === undefined || pageSizeLimit === null)
            throw new Error("The parameter 'pageSizeLimit' must be defined and cannot be null.");
        else
            url_ += "pageSizeLimit=" + encodeURIComponent("" + pageSizeLimit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaylistsSchedules(_response);
        });
    }

    protected processGetPlaylistsSchedules(response: AxiosResponse): Promise<ServerResponseOfListOfPlaylistScheduleDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfListOfPlaylistScheduleDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfListOfPlaylistScheduleDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfListOfPlaylistScheduleDto | null>(null as any);
    }
}

export class UsersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createUser(customerId: string, request: CreateUserDto[] | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    updateUser(customerId: string, request: UpdateUserDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    getUser(customerId: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfUserInfoListDto | null> {
        let url_ = this.baseUrl + "/api/Users/customer/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<ServerResponseOfUserInfoListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfUserInfoListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfUserInfoListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfUserInfoListDto | null>(null as any);
    }

    acceptInvite(request: AcceptInvitationDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/accept/invite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAcceptInvite(_response);
        });
    }

    protected processAcceptInvite(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    sendActivationRequest(customerId: string, email: string | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/send/invite?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendActivationRequest(_response);
        });
    }

    protected processSendActivationRequest(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    archiveUser(customerId: string, email: string | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/archive?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processArchiveUser(_response);
        });
    }

    protected processArchiveUser(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    deleteUser(customerId: string, email: string | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/archive?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    activateUser(customerId: string, email: string | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/activate?";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined and cannot be null.");
        else
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processActivateUser(_response);
        });
    }

    protected processActivateUser(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    changeUserProfile(request: UpdateUserProfileDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfUserInfoListDto | null> {
        let url_ = this.baseUrl + "/api/Users/change/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangeUserProfile(_response);
        });
    }

    protected processChangeUserProfile(response: AxiosResponse): Promise<ServerResponseOfUserInfoListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfUserInfoListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfUserInfoListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfUserInfoListDto | null>(null as any);
    }

    getLoggedInUserInfo(  cancelToken?: CancelToken | undefined): Promise<ServerResponseOfUserInfoListDto | null> {
        let url_ = this.baseUrl + "/api/Users/LoggedIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLoggedInUserInfo(_response);
        });
    }

    protected processGetLoggedInUserInfo(response: AxiosResponse): Promise<ServerResponseOfUserInfoListDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfUserInfoListDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfUserInfoListDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfUserInfoListDto | null>(null as any);
    }

    getUsers(customerId: string | null, searchTerm: string | null | undefined, canManage: boolean | null | undefined, canEditContent: boolean | null | undefined, canViewContent: boolean | null | undefined, canUploadContent: boolean | null | undefined, pageNumber: number | null , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfUserInfoListDto> {
        let url_ = this.baseUrl + "/api/Users?";
        if (customerId === undefined)
            throw new Error("The parameter 'customerId' must be defined.");
        else if(customerId !== null)
            url_ += "customerId=" + encodeURIComponent("" + customerId) + "&";
        if (searchTerm !== undefined && searchTerm !== null)
            url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (canManage !== undefined && canManage !== null)
            url_ += "canManage=" + encodeURIComponent("" + canManage) + "&";
        if (canEditContent !== undefined && canEditContent !== null)
            url_ += "canEditContent=" + encodeURIComponent("" + canEditContent) + "&";
        if (canViewContent !== undefined && canViewContent !== null)
            url_ += "canViewContent=" + encodeURIComponent("" + canViewContent) + "&";
        if (canUploadContent !== undefined && canUploadContent !== null)
            url_ += "canUploadContent=" + encodeURIComponent("" + canUploadContent) + "&";
        if (pageNumber === undefined)
            throw new Error("The parameter 'pageNumber' must be defined.");
        else if(pageNumber !== null)
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsers(_response);
        });
    }

    protected processGetUsers(response: AxiosResponse): Promise<PagedServerResponseOfUserInfoListDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PagedServerResponseOfUserInfoListDto.fromJS(resultData200);
            return Promise.resolve<PagedServerResponseOfUserInfoListDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfUserInfoListDto>(null as any);
    }

    resetUsersPasswordByEmail(request: RequestResetPasswordDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/resetpassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetUsersPasswordByEmail(_response);
        });
    }

    protected processResetUsersPasswordByEmail(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }

    changePasswordByToken(request: UpdatePasswordWithTokenDto | undefined , cancelToken?: CancelToken | undefined): Promise<ServerResponse | null> {
        let url_ = this.baseUrl + "/api/Users/changepassword/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePasswordByToken(_response);
        });
    }

    protected processChangePasswordByToken(response: AxiosResponse): Promise<ServerResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponse.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponse | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponse | null>(null as any);
    }
}

export class WindowsReleaseVersionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getWindowsReleaseVersions(pageNumber: number , cancelToken?: CancelToken | undefined): Promise<PagedServerResponseOfWindowsReleaseVersionDto | null> {
        let url_ = this.baseUrl + "/api/WindowsReleaseVersion/all?";
        if (pageNumber === undefined || pageNumber === null)
            throw new Error("The parameter 'pageNumber' must be defined and cannot be null.");
        else
            url_ += "pageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWindowsReleaseVersions(_response);
        });
    }

    protected processGetWindowsReleaseVersions(response: AxiosResponse): Promise<PagedServerResponseOfWindowsReleaseVersionDto | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedServerResponseOfWindowsReleaseVersionDto.fromJS(resultData200) : <any>null;
            return Promise.resolve<PagedServerResponseOfWindowsReleaseVersionDto | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PagedServerResponseOfWindowsReleaseVersionDto | null>(null as any);
    }

    downloadWindowsReleaseVersion(blobName: string , cancelToken?: CancelToken | undefined): Promise<ServerResponseOfString | null> {
        let url_ = this.baseUrl + "/api/WindowsReleaseVersion/download/{blobName}";
        if (blobName === undefined || blobName === null)
            throw new Error("The parameter 'blobName' must be defined.");
        url_ = url_.replace("{blobName}", encodeURIComponent("" + blobName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadWindowsReleaseVersion(_response);
        });
    }

    protected processDownloadWindowsReleaseVersion(response: AxiosResponse): Promise<ServerResponseOfString | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerResponseOfString.fromJS(resultData200) : <any>null;
            return Promise.resolve<ServerResponseOfString | null>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServerResponseOfString | null>(null as any);
    }
}

export class UpdateAssetDto implements IUpdateAssetDto {
    id!: string;
    name!: string;
    playlistIds!: string[];
    canvasIds?: string[];
    tags!: string[];

    constructor(data?: IUpdateAssetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.playlistIds = [];
            this.tags = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["playlistIds"])) {
                this.playlistIds = [] as any;
                for (let item of _data["playlistIds"])
                    this.playlistIds!.push(item);
            }
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdateAssetDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAssetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.playlistIds)) {
            data["playlistIds"] = [];
            for (let item of this.playlistIds)
                data["playlistIds"].push(item);
        }
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IUpdateAssetDto {
    id: string;
    name: string;
    playlistIds: string[];
    canvasIds?: string[];
    tags: string[];
}

export class ServerResponse implements IServerResponse {
    isSuccessful?: boolean;
    message?: string;

    constructor(data?: IServerResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): ServerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["message"] = this.message;
        return data;
    }
}

export interface IServerResponse {
    isSuccessful?: boolean;
    message?: string;
}

export class ServerResponseOfAssetDetailDto extends ServerResponse implements IServerResponseOfAssetDetailDto {
    data?: AssetDetailDto;

    constructor(data?: IServerResponseOfAssetDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? AssetDetailDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfAssetDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfAssetDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfAssetDetailDto extends IServerResponse {
    data?: AssetDetailDto;
}

export class AssetDetailDto implements IAssetDetailDto {
    id?: string;
    name?: string;
    thumbnailImage?: string;
    type?: string;
    duration?: string;
    width?: number;
    height?: number;
    fileExtension?: string;
    status?: AssetStatus;
    createdAt?: Date;
    tags?: string[];
    fileSize?: number;
    resolution?: string;
    aspectRatio?: string;
    codec?: string;
    blobAddress?: string;
    colorSpace?: string;

    constructor(data?: IAssetDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.thumbnailImage = _data["thumbnailImage"];
            this.type = _data["type"];
            this.duration = _data["duration"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.fileExtension = _data["fileExtension"];
            this.status = _data["status"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.fileSize = _data["fileSize"];
            this.resolution = _data["resolution"];
            this.aspectRatio = _data["aspectRatio"];
            this.codec = _data["codec"];
            this.blobAddress = _data["blobAddress"];
            this.colorSpace = _data["colorSpace"];
        }
    }

    static fromJS(data: any): AssetDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["thumbnailImage"] = this.thumbnailImage;
        data["type"] = this.type;
        data["duration"] = this.duration;
        data["width"] = this.width;
        data["height"] = this.height;
        data["fileExtension"] = this.fileExtension;
        data["status"] = this.status;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["fileSize"] = this.fileSize;
        data["resolution"] = this.resolution;
        data["aspectRatio"] = this.aspectRatio;
        data["codec"] = this.codec;
        data["blobAddress"] = this.blobAddress;
        data["colorSpace"] = this.colorSpace;
        return data;
    }
}

export interface IAssetDetailDto {
    id?: string;
    name?: string;
    thumbnailImage?: string;
    type?: string;
    duration?: string;
    width?: number;
    height?: number;
    fileExtension?: string;
    status?: AssetStatus;
    createdAt?: Date;
    tags?: string[];
    fileSize?: number;
    resolution?: string;
    aspectRatio?: string;
    codec?: string;
    blobAddress?: string;
    colorSpace?: string;
}

export enum AssetStatus {
    Pending = "Pending",
    Uploaded = "Uploaded",
}

export class PagedServerResponseOfAssetListDto implements IPagedServerResponseOfAssetListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: AssetListDto[];

    constructor(data?: IPagedServerResponseOfAssetListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssetListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfAssetListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfAssetListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfAssetListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: AssetListDto[];
}

export class AssetListDto implements IAssetListDto {
    id?: string;
    customerId?: string;
    createdAt?: Date | undefined;
    name?: string;
    thumbnailImage?: string;
    type?: AssetType;
    durationInSecounds?: number;
    width?: number;
    height?: number;
    aspectRatio?: string;
    resolution?: string;
    status?: AssetStatus;
    fileExtension?: string;
    codec?: string;
    canvasIds?: string[];

    constructor(data?: IAssetListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.thumbnailImage = _data["thumbnailImage"];
            this.type = _data["type"];
            this.durationInSecounds = _data["durationInSecounds"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.aspectRatio = _data["aspectRatio"];
            this.resolution = _data["resolution"];
            this.status = _data["status"];
            this.fileExtension = _data["fileExtension"];
            this.codec = _data["codec"];
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["thumbnailImage"] = this.thumbnailImage;
        data["type"] = this.type;
        data["durationInSecounds"] = this.durationInSecounds;
        data["width"] = this.width;
        data["height"] = this.height;
        data["aspectRatio"] = this.aspectRatio;
        data["resolution"] = this.resolution;
        data["status"] = this.status;
        data["fileExtension"] = this.fileExtension;
        data["codec"] = this.codec;
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        return data;
    }
}

export interface IAssetListDto {
    id?: string;
    customerId?: string;
    createdAt?: Date | undefined;
    name?: string;
    thumbnailImage?: string;
    type?: AssetType;
    durationInSecounds?: number;
    width?: number;
    height?: number;
    aspectRatio?: string;
    resolution?: string;
    status?: AssetStatus;
    fileExtension?: string;
    codec?: string;
    canvasIds?: string[];
}

export enum AssetType {
    Video = "Video",
    Image = "Image",
}

export enum AssetSort {
    Date = "Date",
    AspectRatio = "AspectRatio",
    MediaType = "MediaType",
    FileName = "FileName",
    Resolution = "Resolution",
}

export class ServerResponseOfListOfAssetPlaylistListDto extends ServerResponse implements IServerResponseOfListOfAssetPlaylistListDto {
    data?: AssetPlaylistListDto[];

    constructor(data?: IServerResponseOfListOfAssetPlaylistListDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssetPlaylistListDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfAssetPlaylistListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfAssetPlaylistListDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfAssetPlaylistListDto extends IServerResponse {
    data?: AssetPlaylistListDto[];
}

export class AssetPlaylistListDto implements IAssetPlaylistListDto {
    assetPlaylistId?: string;
    id?: string;
    createdAt?: Date | undefined;
    name?: string;
    thumbnailImage?: string;
    type?: AssetType;
    assetDurationInSecound?: number;
    width?: number;
    height?: number;
    aspectRatio?: string;
    resolution?: string;
    fileExtension?: string;
    playlistDurationInSecounds?: number;
    order?: number;

    constructor(data?: IAssetPlaylistListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetPlaylistId = _data["assetPlaylistId"];
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.thumbnailImage = _data["thumbnailImage"];
            this.type = _data["type"];
            this.assetDurationInSecound = _data["assetDurationInSecound"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.aspectRatio = _data["aspectRatio"];
            this.resolution = _data["resolution"];
            this.fileExtension = _data["fileExtension"];
            this.playlistDurationInSecounds = _data["playlistDurationInSecounds"];
            this.order = _data["order"];
        }
    }

    static fromJS(data: any): AssetPlaylistListDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPlaylistListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetPlaylistId"] = this.assetPlaylistId;
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["thumbnailImage"] = this.thumbnailImage;
        data["type"] = this.type;
        data["assetDurationInSecound"] = this.assetDurationInSecound;
        data["width"] = this.width;
        data["height"] = this.height;
        data["aspectRatio"] = this.aspectRatio;
        data["resolution"] = this.resolution;
        data["fileExtension"] = this.fileExtension;
        data["playlistDurationInSecounds"] = this.playlistDurationInSecounds;
        data["order"] = this.order;
        return data;
    }
}

export interface IAssetPlaylistListDto {
    assetPlaylistId?: string;
    id?: string;
    createdAt?: Date | undefined;
    name?: string;
    thumbnailImage?: string;
    type?: AssetType;
    assetDurationInSecound?: number;
    width?: number;
    height?: number;
    aspectRatio?: string;
    resolution?: string;
    fileExtension?: string;
    playlistDurationInSecounds?: number;
    order?: number;
}

export class ServerResponseOfListOfString extends ServerResponse implements IServerResponseOfListOfString {
    data?: string[];

    constructor(data?: IServerResponseOfListOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(item);
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfString extends IServerResponse {
    data?: string[];
}

export class ServerResponseOfListOfAssetUploadStatus extends ServerResponse implements IServerResponseOfListOfAssetUploadStatus {
    data?: AssetUploadStatus[];

    constructor(data?: IServerResponseOfListOfAssetUploadStatus) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AssetUploadStatus.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfAssetUploadStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfAssetUploadStatus();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfAssetUploadStatus extends IServerResponse {
    data?: AssetUploadStatus[];
}

export class AssetUploadStatus implements IAssetUploadStatus {
    connectedDeviceName?: string;
    assetStatus?: AssetConnectedDeviceStatus;

    constructor(data?: IAssetUploadStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.connectedDeviceName = _data["connectedDeviceName"];
            this.assetStatus = _data["assetStatus"];
        }
    }

    static fromJS(data: any): AssetUploadStatus {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUploadStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectedDeviceName"] = this.connectedDeviceName;
        data["assetStatus"] = this.assetStatus;
        return data;
    }
}

export interface IAssetUploadStatus {
    connectedDeviceName?: string;
    assetStatus?: AssetConnectedDeviceStatus;
}

export enum AssetConnectedDeviceStatus {
    UnConfirmed = "UnConfirmed",
    Confirmed = "Confirmed",
    AwaitingActivation = "AwaitingActivation",
}

export class AssetResourceDataDto implements IAssetResourceDataDto {
    resourceFallbackUrl?: string;
    resourceUrl?: string;

    constructor(data?: IAssetResourceDataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resourceFallbackUrl = _data["resourceFallbackUrl"];
            this.resourceUrl = _data["resourceUrl"];
        }
    }

    static fromJS(data: any): AssetResourceDataDto {
        data = typeof data === 'object' ? data : {};
        let result = new AssetResourceDataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceFallbackUrl"] = this.resourceFallbackUrl;
        data["resourceUrl"] = this.resourceUrl;
        return data;
    }
}

export interface IAssetResourceDataDto {
    resourceFallbackUrl?: string;
    resourceUrl?: string;
}

export class ServerResponseOfAssetFilterOptions extends ServerResponse implements IServerResponseOfAssetFilterOptions {
    data?: AssetFilterOptions;

    constructor(data?: IServerResponseOfAssetFilterOptions) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? AssetFilterOptions.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfAssetFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfAssetFilterOptions();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfAssetFilterOptions extends IServerResponse {
    data?: AssetFilterOptions;
}

export class AssetFilterOptions implements IAssetFilterOptions {
    fileTypes?: string[];
    fileCodecs?: string[];
    resolutions?: string[];
    aspectRatios?: string[];
    canvases?: CanvasBasicDto[];
    tags?: string[];

    constructor(data?: IAssetFilterOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fileTypes"])) {
                this.fileTypes = [] as any;
                for (let item of _data["fileTypes"])
                    this.fileTypes!.push(item);
            }
            if (Array.isArray(_data["fileCodecs"])) {
                this.fileCodecs = [] as any;
                for (let item of _data["fileCodecs"])
                    this.fileCodecs!.push(item);
            }
            if (Array.isArray(_data["resolutions"])) {
                this.resolutions = [] as any;
                for (let item of _data["resolutions"])
                    this.resolutions!.push(item);
            }
            if (Array.isArray(_data["aspectRatios"])) {
                this.aspectRatios = [] as any;
                for (let item of _data["aspectRatios"])
                    this.aspectRatios!.push(item);
            }
            if (Array.isArray(_data["canvases"])) {
                this.canvases = [] as any;
                for (let item of _data["canvases"])
                    this.canvases!.push(CanvasBasicDto.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
        }
    }

    static fromJS(data: any): AssetFilterOptions {
        data = typeof data === 'object' ? data : {};
        let result = new AssetFilterOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fileTypes)) {
            data["fileTypes"] = [];
            for (let item of this.fileTypes)
                data["fileTypes"].push(item);
        }
        if (Array.isArray(this.fileCodecs)) {
            data["fileCodecs"] = [];
            for (let item of this.fileCodecs)
                data["fileCodecs"].push(item);
        }
        if (Array.isArray(this.resolutions)) {
            data["resolutions"] = [];
            for (let item of this.resolutions)
                data["resolutions"].push(item);
        }
        if (Array.isArray(this.aspectRatios)) {
            data["aspectRatios"] = [];
            for (let item of this.aspectRatios)
                data["aspectRatios"].push(item);
        }
        if (Array.isArray(this.canvases)) {
            data["canvases"] = [];
            for (let item of this.canvases)
                data["canvases"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        return data;
    }
}

export interface IAssetFilterOptions {
    fileTypes?: string[];
    fileCodecs?: string[];
    resolutions?: string[];
    aspectRatios?: string[];
    canvases?: CanvasBasicDto[];
    tags?: string[];
}

export class CanvasBasicDto implements ICanvasBasicDto {
    id?: string;
    name?: string;
    siteId?: number;
    multiplexNumber?: number;

    constructor(data?: ICanvasBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.siteId = _data["siteId"];
            this.multiplexNumber = _data["multiplexNumber"];
        }
    }

    static fromJS(data: any): CanvasBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new CanvasBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["siteId"] = this.siteId;
        data["multiplexNumber"] = this.multiplexNumber;
        return data;
    }
}

export interface ICanvasBasicDto {
    id?: string;
    name?: string;
    siteId?: number;
    multiplexNumber?: number;
}

export class AssetPreviewRequest implements IAssetPreviewRequest {
    customerId?: string;
    assetId?: string;
    assetFileExtension?: string;
    canvasId?: string;

    constructor(data?: IAssetPreviewRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.assetId = _data["assetId"];
            this.assetFileExtension = _data["assetFileExtension"];
            this.canvasId = _data["canvasId"];
        }
    }

    static fromJS(data: any): AssetPreviewRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPreviewRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["assetId"] = this.assetId;
        data["assetFileExtension"] = this.assetFileExtension;
        data["canvasId"] = this.canvasId;
        return data;
    }
}

export interface IAssetPreviewRequest {
    customerId?: string;
    assetId?: string;
    assetFileExtension?: string;
    canvasId?: string;
}

export class AssetPreviewStopRequest implements IAssetPreviewStopRequest {
    customerId?: string;
    canvasId?: string;
    assetId?: string;

    constructor(data?: IAssetPreviewStopRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.canvasId = _data["canvasId"];
            this.assetId = _data["assetId"];
        }
    }

    static fromJS(data: any): AssetPreviewStopRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPreviewStopRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["canvasId"] = this.canvasId;
        data["assetId"] = this.assetId;
        return data;
    }
}

export interface IAssetPreviewStopRequest {
    customerId?: string;
    canvasId?: string;
    assetId?: string;
}

export class ServerResponseOfListOfAuditLogDto extends ServerResponse implements IServerResponseOfListOfAuditLogDto {
    data?: AuditLogDto[];

    constructor(data?: IServerResponseOfListOfAuditLogDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(AuditLogDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfAuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfAuditLogDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfAuditLogDto extends IServerResponse {
    data?: AuditLogDto[];
}

export class AuditLogDto implements IAuditLogDto {
    id?: string;
    createdAt?: Date;
    type?: ActionType;
    description?: string;
    userFullName?: string;

    constructor(data?: IAuditLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.type = _data["type"];
            this.description = _data["description"];
            this.userFullName = _data["userFullName"];
        }
    }

    static fromJS(data: any): AuditLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["type"] = this.type;
        data["description"] = this.description;
        data["userFullName"] = this.userFullName;
        return data;
    }
}

export interface IAuditLogDto {
    id?: string;
    createdAt?: Date;
    type?: ActionType;
    description?: string;
    userFullName?: string;
}

export enum ActionType {
    AssetCreated = "AssetCreated",
    AssetUpdated = "AssetUpdated",
    AssetAddedToPlaylist = "AssetAddedToPlaylist",
    AssetRemovedFromPlaylist = "AssetRemovedFromPlaylist",
    AssetAddedToCanvas = "AssetAddedToCanvas",
    AssetRemovedFromCanvas = "AssetRemovedFromCanvas",
    AssetScheduled = "AssetScheduled",
    AssetUnscheduled = "AssetUnscheduled",
}

export class ServerResponseOfString extends ServerResponse implements IServerResponseOfString {
    data?: string;

    constructor(data?: IServerResponseOfString) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static override fromJS(data: any): ServerResponseOfString {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfString();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfString extends IServerResponse {
    data?: string;
}

export class ServerResponseWithId extends ServerResponseOfString implements IServerResponseWithId {

    constructor(data?: IServerResponseWithId) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ServerResponseWithId {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseWithId();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseWithId extends IServerResponseOfString {
}

export class CreateCanvasDto implements ICreateCanvasDto {
    name?: string;
    description?: string;
    ipAddress?: string;
    resolution?: string;
    heightResolution?: number;
    widthResolution?: number;
    siteId?: number;
    multiplexNumber?: number;

    constructor(data?: ICreateCanvasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.ipAddress = _data["ipAddress"];
            this.resolution = _data["resolution"];
            this.heightResolution = _data["heightResolution"];
            this.widthResolution = _data["widthResolution"];
            this.siteId = _data["siteId"];
            this.multiplexNumber = _data["multiplexNumber"];
        }
    }

    static fromJS(data: any): CreateCanvasDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCanvasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["ipAddress"] = this.ipAddress;
        data["resolution"] = this.resolution;
        data["heightResolution"] = this.heightResolution;
        data["widthResolution"] = this.widthResolution;
        data["siteId"] = this.siteId;
        data["multiplexNumber"] = this.multiplexNumber;
        return data;
    }
}

export interface ICreateCanvasDto {
    name?: string;
    description?: string;
    ipAddress?: string;
    resolution?: string;
    heightResolution?: number;
    widthResolution?: number;
    siteId?: number;
    multiplexNumber?: number;
}

export class ServerResponseOfCanvasListDto extends ServerResponse implements IServerResponseOfCanvasListDto {
    data?: CanvasListDto;

    constructor(data?: IServerResponseOfCanvasListDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CanvasListDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfCanvasListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfCanvasListDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfCanvasListDto extends IServerResponse {
    data?: CanvasListDto;
}

export class CanvasListDto implements ICanvasListDto {
    id?: string;
    name?: string;
    description?: string;
    ipAddress?: string;
    heightResolution?: number;
    widthResolution?: number;
    siteId?: number;
    multiplexNumber?: number;

    constructor(data?: ICanvasListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ipAddress = _data["ipAddress"];
            this.heightResolution = _data["heightResolution"];
            this.widthResolution = _data["widthResolution"];
            this.siteId = _data["siteId"];
            this.multiplexNumber = _data["multiplexNumber"];
        }
    }

    static fromJS(data: any): CanvasListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CanvasListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ipAddress"] = this.ipAddress;
        data["heightResolution"] = this.heightResolution;
        data["widthResolution"] = this.widthResolution;
        data["siteId"] = this.siteId;
        data["multiplexNumber"] = this.multiplexNumber;
        return data;
    }
}

export interface ICanvasListDto {
    id?: string;
    name?: string;
    description?: string;
    ipAddress?: string;
    heightResolution?: number;
    widthResolution?: number;
    siteId?: number;
    multiplexNumber?: number;
}

export class UpdateCanvasDto implements IUpdateCanvasDto {
    id?: string;
    name?: string;
    description?: string;
    ipAddress?: string;
    resolution?: string;
    heightResolution?: number;
    widthResolution?: number;
    siteId?: number;
    multiplexNumber?: number;

    constructor(data?: IUpdateCanvasDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.ipAddress = _data["ipAddress"];
            this.resolution = _data["resolution"];
            this.heightResolution = _data["heightResolution"];
            this.widthResolution = _data["widthResolution"];
            this.siteId = _data["siteId"];
            this.multiplexNumber = _data["multiplexNumber"];
        }
    }

    static fromJS(data: any): UpdateCanvasDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCanvasDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["ipAddress"] = this.ipAddress;
        data["resolution"] = this.resolution;
        data["heightResolution"] = this.heightResolution;
        data["widthResolution"] = this.widthResolution;
        data["siteId"] = this.siteId;
        data["multiplexNumber"] = this.multiplexNumber;
        return data;
    }
}

export interface IUpdateCanvasDto {
    id?: string;
    name?: string;
    description?: string;
    ipAddress?: string;
    resolution?: string;
    heightResolution?: number;
    widthResolution?: number;
    siteId?: number;
    multiplexNumber?: number;
}

export class PagedServerResponseOfCanvasListDto implements IPagedServerResponseOfCanvasListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: CanvasListDto[];

    constructor(data?: IPagedServerResponseOfCanvasListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CanvasListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfCanvasListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfCanvasListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfCanvasListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: CanvasListDto[];
}

export class ServerResponseOfListOfCanvasBasicDto extends ServerResponse implements IServerResponseOfListOfCanvasBasicDto {
    data?: CanvasBasicDto[];

    constructor(data?: IServerResponseOfListOfCanvasBasicDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CanvasBasicDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfCanvasBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfCanvasBasicDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfCanvasBasicDto extends IServerResponse {
    data?: CanvasBasicDto[];
}

export class CreateConnectedDeviceDto implements ICreateConnectedDeviceDto {
    customerId?: string;
    registerationCode?: string;

    constructor(data?: ICreateConnectedDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.registerationCode = _data["registerationCode"];
        }
    }

    static fromJS(data: any): CreateConnectedDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConnectedDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["registerationCode"] = this.registerationCode;
        return data;
    }
}

export interface ICreateConnectedDeviceDto {
    customerId?: string;
    registerationCode?: string;
}

export class ConnectedDeviceListDto implements IConnectedDeviceListDto {
    id?: string;
    customerId?: string;
    name?: string;
    masterIpAddress?: string;
    registerationCode?: string;
    lastConnection?: Date;
    status?: ConnectedDeviceStatus;

    constructor(data?: IConnectedDeviceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.masterIpAddress = _data["masterIpAddress"];
            this.registerationCode = _data["registerationCode"];
            this.lastConnection = _data["lastConnection"] ? new Date(_data["lastConnection"].toString()) : <any>undefined;
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): ConnectedDeviceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectedDeviceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["masterIpAddress"] = this.masterIpAddress;
        data["registerationCode"] = this.registerationCode;
        data["lastConnection"] = this.lastConnection ? this.lastConnection.toISOString() : <any>undefined;
        data["status"] = this.status;
        return data;
    }
}

export interface IConnectedDeviceListDto {
    id?: string;
    customerId?: string;
    name?: string;
    masterIpAddress?: string;
    registerationCode?: string;
    lastConnection?: Date;
    status?: ConnectedDeviceStatus;
}

export enum ConnectedDeviceStatus {
    Pending = "Pending",
    Active = "Active",
}

export class UpdateConnectedDeviceDto implements IUpdateConnectedDeviceDto {
    id?: string;
    name?: string;
    masterIpAddress?: string;

    constructor(data?: IUpdateConnectedDeviceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.masterIpAddress = _data["masterIpAddress"];
        }
    }

    static fromJS(data: any): UpdateConnectedDeviceDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateConnectedDeviceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["masterIpAddress"] = this.masterIpAddress;
        return data;
    }
}

export interface IUpdateConnectedDeviceDto {
    id?: string;
    name?: string;
    masterIpAddress?: string;
}

export class ConnectedDeviceDetailDto implements IConnectedDeviceDetailDto {
    id?: string;
    customerId?: string;
    name?: string;
    masterIpAddress?: string;
    registerationCode?: string;
    lastConnection?: Date;

    constructor(data?: IConnectedDeviceDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.masterIpAddress = _data["masterIpAddress"];
            this.registerationCode = _data["registerationCode"];
            this.lastConnection = _data["lastConnection"] ? new Date(_data["lastConnection"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ConnectedDeviceDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConnectedDeviceDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["masterIpAddress"] = this.masterIpAddress;
        data["registerationCode"] = this.registerationCode;
        data["lastConnection"] = this.lastConnection ? this.lastConnection.toISOString() : <any>undefined;
        return data;
    }
}

export interface IConnectedDeviceDetailDto {
    id?: string;
    customerId?: string;
    name?: string;
    masterIpAddress?: string;
    registerationCode?: string;
    lastConnection?: Date;
}

export class PagedServerResponseOfConnectedDeviceListDto implements IPagedServerResponseOfConnectedDeviceListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: ConnectedDeviceListDto[];

    constructor(data?: IPagedServerResponseOfConnectedDeviceListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(ConnectedDeviceListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfConnectedDeviceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfConnectedDeviceListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfConnectedDeviceListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: ConnectedDeviceListDto[];
}

export class ServerResponseOfConnectedDeviceListDto extends ServerResponse implements IServerResponseOfConnectedDeviceListDto {
    data?: ConnectedDeviceListDto;

    constructor(data?: IServerResponseOfConnectedDeviceListDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? ConnectedDeviceListDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfConnectedDeviceListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfConnectedDeviceListDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfConnectedDeviceListDto extends IServerResponse {
    data?: ConnectedDeviceListDto;
}

export class CreateCustomerDto implements ICreateCustomerDto {
    name?: string;
    allowedCanvasesCount?: number;
    logo?: string | undefined;
    timeZone?: number;
    timeZoneName?: string;
    storageLimit?: number | undefined;

    constructor(data?: ICreateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.allowedCanvasesCount = _data["allowedCanvasesCount"];
            this.logo = _data["logo"];
            this.timeZone = _data["timeZone"];
            this.timeZoneName = _data["timeZoneName"];
            this.storageLimit = _data["storageLimit"];
        }
    }

    static fromJS(data: any): CreateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["allowedCanvasesCount"] = this.allowedCanvasesCount;
        data["logo"] = this.logo;
        data["timeZone"] = this.timeZone;
        data["timeZoneName"] = this.timeZoneName;
        data["storageLimit"] = this.storageLimit;
        return data;
    }
}

export interface ICreateCustomerDto {
    name?: string;
    allowedCanvasesCount?: number;
    logo?: string | undefined;
    timeZone?: number;
    timeZoneName?: string;
    storageLimit?: number | undefined;
}

export class ServerResponseOfCustomerListDto extends ServerResponse implements IServerResponseOfCustomerListDto {
    data?: CustomerListDto;

    constructor(data?: IServerResponseOfCustomerListDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? CustomerListDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfCustomerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfCustomerListDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfCustomerListDto extends IServerResponse {
    data?: CustomerListDto;
}

export class CustomerListDto implements ICustomerListDto {
    id?: string;
    logo?: string;
    name?: string;
    allowedCanvasesCount?: number;
    status?: CustomerStatus;
    timeZone?: number;
    timeZoneInfo?: CustomerTimeZoneDto;
    totalFileSizedUsed?: number;
    storageLimit?: number | undefined;
    canvasesCount?: number;

    constructor(data?: ICustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logo = _data["logo"];
            this.name = _data["name"];
            this.allowedCanvasesCount = _data["allowedCanvasesCount"];
            this.status = _data["status"];
            this.timeZone = _data["timeZone"];
            this.timeZoneInfo = _data["timeZoneInfo"] ? CustomerTimeZoneDto.fromJS(_data["timeZoneInfo"]) : <any>undefined;
            this.totalFileSizedUsed = _data["totalFileSizedUsed"];
            this.storageLimit = _data["storageLimit"];
            this.canvasesCount = _data["canvasesCount"];
        }
    }

    static fromJS(data: any): CustomerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logo"] = this.logo;
        data["name"] = this.name;
        data["allowedCanvasesCount"] = this.allowedCanvasesCount;
        data["status"] = this.status;
        data["timeZone"] = this.timeZone;
        data["timeZoneInfo"] = this.timeZoneInfo ? this.timeZoneInfo.toJSON() : <any>undefined;
        data["totalFileSizedUsed"] = this.totalFileSizedUsed;
        data["storageLimit"] = this.storageLimit;
        data["canvasesCount"] = this.canvasesCount;
        return data;
    }
}

export interface ICustomerListDto {
    id?: string;
    logo?: string;
    name?: string;
    allowedCanvasesCount?: number;
    status?: CustomerStatus;
    timeZone?: number;
    timeZoneInfo?: CustomerTimeZoneDto;
    totalFileSizedUsed?: number;
    storageLimit?: number | undefined;
    canvasesCount?: number;
}

export enum CustomerStatus {
    Active = "Active",
    Archived = "Archived",
}

export class CustomerTimeZoneDto implements ICustomerTimeZoneDto {
    timeZoneName?: string;
    timeZoneIANA?: string;
    timeZoneOffset?: string;

    constructor(data?: ICustomerTimeZoneDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeZoneName = _data["timeZoneName"];
            this.timeZoneIANA = _data["timeZoneIANA"];
            this.timeZoneOffset = _data["timeZoneOffset"];
        }
    }

    static fromJS(data: any): CustomerTimeZoneDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTimeZoneDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeZoneName"] = this.timeZoneName;
        data["timeZoneIANA"] = this.timeZoneIANA;
        data["timeZoneOffset"] = this.timeZoneOffset;
        return data;
    }
}

export interface ICustomerTimeZoneDto {
    timeZoneName?: string;
    timeZoneIANA?: string;
    timeZoneOffset?: string;
}

export class UpdateCustomerDto implements IUpdateCustomerDto {
    id?: string;
    name?: string;
    allowedCanvasesCount?: number;
    logo?: string | undefined;
    timeZone?: number;
    timeZoneName?: string;
    storageLimit?: number | undefined;

    constructor(data?: IUpdateCustomerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.allowedCanvasesCount = _data["allowedCanvasesCount"];
            this.logo = _data["logo"];
            this.timeZone = _data["timeZone"];
            this.timeZoneName = _data["timeZoneName"];
            this.storageLimit = _data["storageLimit"];
        }
    }

    static fromJS(data: any): UpdateCustomerDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCustomerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["allowedCanvasesCount"] = this.allowedCanvasesCount;
        data["logo"] = this.logo;
        data["timeZone"] = this.timeZone;
        data["timeZoneName"] = this.timeZoneName;
        data["storageLimit"] = this.storageLimit;
        return data;
    }
}

export interface IUpdateCustomerDto {
    id?: string;
    name?: string;
    allowedCanvasesCount?: number;
    logo?: string | undefined;
    timeZone?: number;
    timeZoneName?: string;
    storageLimit?: number | undefined;
}

export class PagedServerResponseOfCustomerListDto implements IPagedServerResponseOfCustomerListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: CustomerListDto[];

    constructor(data?: IPagedServerResponseOfCustomerListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(CustomerListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfCustomerListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfCustomerListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfCustomerListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: CustomerListDto[];
}

export class ServerResponseOfListOfSelectListDto extends ServerResponse implements IServerResponseOfListOfSelectListDto {
    data?: SelectListDto[];

    constructor(data?: IServerResponseOfListOfSelectListDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(SelectListDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfSelectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfSelectListDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfSelectListDto extends IServerResponse {
    data?: SelectListDto[];
}

export class SelectListDto implements ISelectListDto {
    value?: string;
    label?: string;

    constructor(data?: ISelectListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.label = _data["label"];
        }
    }

    static fromJS(data: any): SelectListDto {
        data = typeof data === 'object' ? data : {};
        let result = new SelectListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["label"] = this.label;
        return data;
    }
}

export interface ISelectListDto {
    value?: string;
    label?: string;
}

export class ServerResponseOfDouble extends ServerResponse implements IServerResponseOfDouble {
    data?: number;

    constructor(data?: IServerResponseOfDouble) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static override fromJS(data: any): ServerResponseOfDouble {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfDouble();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfDouble extends IServerResponse {
    data?: number;
}

export class CreatePlaylistDto implements ICreatePlaylistDto {
    name!: string;
    description?: string;
    color!: string;
    transitionDurationInSecounds?: number;
    defaultImageDurationInSecounds?: number;
    canvasIds?: string[];

    constructor(data?: ICreatePlaylistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.transitionDurationInSecounds = _data["transitionDurationInSecounds"];
            this.defaultImageDurationInSecounds = _data["defaultImageDurationInSecounds"];
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreatePlaylistDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreatePlaylistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["transitionDurationInSecounds"] = this.transitionDurationInSecounds;
        data["defaultImageDurationInSecounds"] = this.defaultImageDurationInSecounds;
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        return data;
    }
}

export interface ICreatePlaylistDto {
    name: string;
    description?: string;
    color: string;
    transitionDurationInSecounds?: number;
    defaultImageDurationInSecounds?: number;
    canvasIds?: string[];
}

export class UpdatePlaylistDto implements IUpdatePlaylistDto {
    id?: string;
    name?: string;
    description?: string;
    color?: string;
    transitionDurationInSecounds?: number;
    defaultImageDurationInSecounds?: number;
    updatePlaylistAssets?: PutAssetPlaylistDto[];
    canvasIds?: string[];

    constructor(data?: IUpdatePlaylistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.transitionDurationInSecounds = _data["transitionDurationInSecounds"];
            this.defaultImageDurationInSecounds = _data["defaultImageDurationInSecounds"];
            if (Array.isArray(_data["updatePlaylistAssets"])) {
                this.updatePlaylistAssets = [] as any;
                for (let item of _data["updatePlaylistAssets"])
                    this.updatePlaylistAssets!.push(PutAssetPlaylistDto.fromJS(item));
            }
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
        }
    }

    static fromJS(data: any): UpdatePlaylistDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlaylistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["transitionDurationInSecounds"] = this.transitionDurationInSecounds;
        data["defaultImageDurationInSecounds"] = this.defaultImageDurationInSecounds;
        if (Array.isArray(this.updatePlaylistAssets)) {
            data["updatePlaylistAssets"] = [];
            for (let item of this.updatePlaylistAssets)
                data["updatePlaylistAssets"].push(item.toJSON());
        }
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        return data;
    }
}

export interface IUpdatePlaylistDto {
    id?: string;
    name?: string;
    description?: string;
    color?: string;
    transitionDurationInSecounds?: number;
    defaultImageDurationInSecounds?: number;
    updatePlaylistAssets?: PutAssetPlaylistDto[];
    canvasIds?: string[];
}

export class PutAssetPlaylistDto implements IPutAssetPlaylistDto {
    assetPlaylistId?: string | undefined;
    assetId?: string;
    durationInSecound?: number;

    constructor(data?: IPutAssetPlaylistDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetPlaylistId = _data["assetPlaylistId"];
            this.assetId = _data["assetId"];
            this.durationInSecound = _data["durationInSecound"];
        }
    }

    static fromJS(data: any): PutAssetPlaylistDto {
        data = typeof data === 'object' ? data : {};
        let result = new PutAssetPlaylistDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetPlaylistId"] = this.assetPlaylistId;
        data["assetId"] = this.assetId;
        data["durationInSecound"] = this.durationInSecound;
        return data;
    }
}

export interface IPutAssetPlaylistDto {
    assetPlaylistId?: string | undefined;
    assetId?: string;
    durationInSecound?: number;
}

export class PagedServerResponseOfPlaylistListDto implements IPagedServerResponseOfPlaylistListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: PlaylistListDto[];

    constructor(data?: IPagedServerResponseOfPlaylistListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlaylistListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfPlaylistListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfPlaylistListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfPlaylistListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: PlaylistListDto[];
}

export class PlaylistListDto implements IPlaylistListDto {
    id?: string;
    lastUpdatedAt?: Date;
    name?: string;
    color?: string;
    assetsCount?: number;
    totalDurationInSecound?: number;
    nextUpcomingSchedule?: Date | undefined;
    canvasIds?: string[];

    constructor(data?: IPlaylistListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.color = _data["color"];
            this.assetsCount = _data["assetsCount"];
            this.totalDurationInSecound = _data["totalDurationInSecound"];
            this.nextUpcomingSchedule = _data["nextUpcomingSchedule"] ? new Date(_data["nextUpcomingSchedule"].toString()) : <any>undefined;
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PlaylistListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["color"] = this.color;
        data["assetsCount"] = this.assetsCount;
        data["totalDurationInSecound"] = this.totalDurationInSecound;
        data["nextUpcomingSchedule"] = this.nextUpcomingSchedule ? this.nextUpcomingSchedule.toISOString() : <any>undefined;
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        return data;
    }
}

export interface IPlaylistListDto {
    id?: string;
    lastUpdatedAt?: Date;
    name?: string;
    color?: string;
    assetsCount?: number;
    totalDurationInSecound?: number;
    nextUpcomingSchedule?: Date | undefined;
    canvasIds?: string[];
}

export class ServerResponseOfListOfPlaylistBasicDto extends ServerResponse implements IServerResponseOfListOfPlaylistBasicDto {
    data?: PlaylistBasicDto[];

    constructor(data?: IServerResponseOfListOfPlaylistBasicDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlaylistBasicDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfPlaylistBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfPlaylistBasicDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfPlaylistBasicDto extends IServerResponse {
    data?: PlaylistBasicDto[];
}

export class PlaylistBasicDto implements IPlaylistBasicDto {
    id?: string;
    name?: string;
    color?: string;
    transitionDurationInSecounds?: number;
    canvasIds?: string[];

    constructor(data?: IPlaylistBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.transitionDurationInSecounds = _data["transitionDurationInSecounds"];
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PlaylistBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["color"] = this.color;
        data["transitionDurationInSecounds"] = this.transitionDurationInSecounds;
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        return data;
    }
}

export interface IPlaylistBasicDto {
    id?: string;
    name?: string;
    color?: string;
    transitionDurationInSecounds?: number;
    canvasIds?: string[];
}

export class ServerResponseOfPlaylistDetailDto extends ServerResponse implements IServerResponseOfPlaylistDetailDto {
    data?: PlaylistDetailDto;

    constructor(data?: IServerResponseOfPlaylistDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PlaylistDetailDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfPlaylistDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfPlaylistDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfPlaylistDetailDto extends IServerResponse {
    data?: PlaylistDetailDto;
}

export class PlaylistDetailDto implements IPlaylistDetailDto {
    id?: string;
    lastUpdatedAt?: Date;
    name?: string;
    description?: string;
    color?: string;
    assetsCount?: number;
    totalDurationInSecound?: number;
    defaultImageDurationInSecounds?: number;
    transitionDurationInSecounds?: number;
    canvasIds?: string[];

    constructor(data?: IPlaylistDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.assetsCount = _data["assetsCount"];
            this.totalDurationInSecound = _data["totalDurationInSecound"];
            this.defaultImageDurationInSecounds = _data["defaultImageDurationInSecounds"];
            this.transitionDurationInSecounds = _data["transitionDurationInSecounds"];
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PlaylistDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["assetsCount"] = this.assetsCount;
        data["totalDurationInSecound"] = this.totalDurationInSecound;
        data["defaultImageDurationInSecounds"] = this.defaultImageDurationInSecounds;
        data["transitionDurationInSecounds"] = this.transitionDurationInSecounds;
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        return data;
    }
}

export interface IPlaylistDetailDto {
    id?: string;
    lastUpdatedAt?: Date;
    name?: string;
    description?: string;
    color?: string;
    assetsCount?: number;
    totalDurationInSecound?: number;
    defaultImageDurationInSecounds?: number;
    transitionDurationInSecounds?: number;
    canvasIds?: string[];
}

export class ServerResponseOfPlaylistFullDetailDto extends ServerResponse implements IServerResponseOfPlaylistFullDetailDto {
    data?: PlaylistFullDetailDto;

    constructor(data?: IServerResponseOfPlaylistFullDetailDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? PlaylistFullDetailDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfPlaylistFullDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfPlaylistFullDetailDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfPlaylistFullDetailDto extends IServerResponse {
    data?: PlaylistFullDetailDto;
}

export class PlaylistFullDetailDto implements IPlaylistFullDetailDto {
    id?: string;
    lastUpdatedAt?: Date;
    name?: string;
    description?: string;
    color?: string;
    assetsCount?: number;
    totalDurationInSecound?: number;
    defaultImageDurationInSecounds?: number;
    transitionDurationInSecounds?: number;
    canvasIds?: string[];
    assets?: AssetPlaylistListDto[];

    constructor(data?: IPlaylistFullDetailDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.lastUpdatedAt = _data["lastUpdatedAt"] ? new Date(_data["lastUpdatedAt"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.color = _data["color"];
            this.assetsCount = _data["assetsCount"];
            this.totalDurationInSecound = _data["totalDurationInSecound"];
            this.defaultImageDurationInSecounds = _data["defaultImageDurationInSecounds"];
            this.transitionDurationInSecounds = _data["transitionDurationInSecounds"];
            if (Array.isArray(_data["canvasIds"])) {
                this.canvasIds = [] as any;
                for (let item of _data["canvasIds"])
                    this.canvasIds!.push(item);
            }
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(AssetPlaylistListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlaylistFullDetailDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistFullDetailDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["lastUpdatedAt"] = this.lastUpdatedAt ? this.lastUpdatedAt.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["color"] = this.color;
        data["assetsCount"] = this.assetsCount;
        data["totalDurationInSecound"] = this.totalDurationInSecound;
        data["defaultImageDurationInSecounds"] = this.defaultImageDurationInSecounds;
        data["transitionDurationInSecounds"] = this.transitionDurationInSecounds;
        if (Array.isArray(this.canvasIds)) {
            data["canvasIds"] = [];
            for (let item of this.canvasIds)
                data["canvasIds"].push(item);
        }
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlaylistFullDetailDto {
    id?: string;
    lastUpdatedAt?: Date;
    name?: string;
    description?: string;
    color?: string;
    assetsCount?: number;
    totalDurationInSecound?: number;
    defaultImageDurationInSecounds?: number;
    transitionDurationInSecounds?: number;
    canvasIds?: string[];
    assets?: AssetPlaylistListDto[];
}

export class ChangeScheduleRequest implements IChangeScheduleRequest {
    canvasId?: string;
    startDate?: Date;
    endDate?: Date;
    recurringType?: RecurringType;
    recurringDays?: DayOfWeek[];
    recurringEndDateTime?: Date | undefined;

    constructor(data?: IChangeScheduleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canvasId = _data["canvasId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recurringType = _data["recurringType"];
            if (Array.isArray(_data["recurringDays"])) {
                this.recurringDays = [] as any;
                for (let item of _data["recurringDays"])
                    this.recurringDays!.push(item);
            }
            this.recurringEndDateTime = _data["recurringEndDateTime"] ? new Date(_data["recurringEndDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ChangeScheduleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeScheduleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canvasId"] = this.canvasId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recurringType"] = this.recurringType;
        if (Array.isArray(this.recurringDays)) {
            data["recurringDays"] = [];
            for (let item of this.recurringDays)
                data["recurringDays"].push(item);
        }
        data["recurringEndDateTime"] = this.recurringEndDateTime ? this.recurringEndDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IChangeScheduleRequest {
    canvasId?: string;
    startDate?: Date;
    endDate?: Date;
    recurringType?: RecurringType;
    recurringDays?: DayOfWeek[];
    recurringEndDateTime?: Date | undefined;
}

export class CreateScheduleDto extends ChangeScheduleRequest implements ICreateScheduleDto {
    resourceId?: string;
    isPlaylist?: boolean;

    constructor(data?: ICreateScheduleDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.resourceId = _data["resourceId"];
            this.isPlaylist = _data["isPlaylist"];
        }
    }

    static override fromJS(data: any): CreateScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateScheduleDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resourceId"] = this.resourceId;
        data["isPlaylist"] = this.isPlaylist;
        super.toJSON(data);
        return data;
    }
}

export interface ICreateScheduleDto extends IChangeScheduleRequest {
    resourceId?: string;
    isPlaylist?: boolean;
}

export enum RecurringType {
    None = "None",
    Daily = "Daily",
    Weekly = "Weekly",
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class UpdateScheduleDto extends ChangeScheduleRequest implements IUpdateScheduleDto {
    id?: string;
    recurringStartDateTime?: Date;

    constructor(data?: IUpdateScheduleDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.recurringStartDateTime = _data["recurringStartDateTime"] ? new Date(_data["recurringStartDateTime"].toString()) : <any>undefined;
        }
    }

    static override fromJS(data: any): UpdateScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateScheduleDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["recurringStartDateTime"] = this.recurringStartDateTime ? this.recurringStartDateTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IUpdateScheduleDto extends IChangeScheduleRequest {
    id?: string;
    recurringStartDateTime?: Date;
}

export class ServerResponseOfSchedulesWithCanvases extends ServerResponse implements IServerResponseOfSchedulesWithCanvases {
    data?: SchedulesWithCanvases;

    constructor(data?: IServerResponseOfSchedulesWithCanvases) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? SchedulesWithCanvases.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfSchedulesWithCanvases {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfSchedulesWithCanvases();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfSchedulesWithCanvases extends IServerResponse {
    data?: SchedulesWithCanvases;
}

export class SchedulesWithCanvases implements ISchedulesWithCanvases {
    canvases?: CanvasBasicDto[];
    schedules?: ScheduleListDto[];

    constructor(data?: ISchedulesWithCanvases) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["canvases"])) {
                this.canvases = [] as any;
                for (let item of _data["canvases"])
                    this.canvases!.push(CanvasBasicDto.fromJS(item));
            }
            if (Array.isArray(_data["schedules"])) {
                this.schedules = [] as any;
                for (let item of _data["schedules"])
                    this.schedules!.push(ScheduleListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SchedulesWithCanvases {
        data = typeof data === 'object' ? data : {};
        let result = new SchedulesWithCanvases();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.canvases)) {
            data["canvases"] = [];
            for (let item of this.canvases)
                data["canvases"].push(item.toJSON());
        }
        if (Array.isArray(this.schedules)) {
            data["schedules"] = [];
            for (let item of this.schedules)
                data["schedules"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISchedulesWithCanvases {
    canvases?: CanvasBasicDto[];
    schedules?: ScheduleListDto[];
}

export class ScheduleListDto implements IScheduleListDto {
    id?: string;
    customerId?: string;
    resourceId?: string;
    canvasId?: string;
    name?: string;
    color?: string;
    assetThumbnail?: string;
    resourceType?: ScheduleResourceType;
    startDate?: Date;
    endDate?: Date;
    recurringType?: RecurringType;
    recurringDays?: DayOfWeek[];
    recurringStartDateTime?: Date;
    recurringEndDateTime?: Date | undefined;

    constructor(data?: IScheduleListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.resourceId = _data["resourceId"];
            this.canvasId = _data["canvasId"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.assetThumbnail = _data["assetThumbnail"];
            this.resourceType = _data["resourceType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recurringType = _data["recurringType"];
            if (Array.isArray(_data["recurringDays"])) {
                this.recurringDays = [] as any;
                for (let item of _data["recurringDays"])
                    this.recurringDays!.push(item);
            }
            this.recurringStartDateTime = _data["recurringStartDateTime"] ? new Date(_data["recurringStartDateTime"].toString()) : <any>undefined;
            this.recurringEndDateTime = _data["recurringEndDateTime"] ? new Date(_data["recurringEndDateTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ScheduleListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["resourceId"] = this.resourceId;
        data["canvasId"] = this.canvasId;
        data["name"] = this.name;
        data["color"] = this.color;
        data["assetThumbnail"] = this.assetThumbnail;
        data["resourceType"] = this.resourceType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recurringType"] = this.recurringType;
        if (Array.isArray(this.recurringDays)) {
            data["recurringDays"] = [];
            for (let item of this.recurringDays)
                data["recurringDays"].push(item);
        }
        data["recurringStartDateTime"] = this.recurringStartDateTime ? this.recurringStartDateTime.toISOString() : <any>undefined;
        data["recurringEndDateTime"] = this.recurringEndDateTime ? this.recurringEndDateTime.toISOString() : <any>undefined;
        return data;
    }
}

export interface IScheduleListDto {
    id?: string;
    customerId?: string;
    resourceId?: string;
    canvasId?: string;
    name?: string;
    color?: string;
    assetThumbnail?: string;
    resourceType?: ScheduleResourceType;
    startDate?: Date;
    endDate?: Date;
    recurringType?: RecurringType;
    recurringDays?: DayOfWeek[];
    recurringStartDateTime?: Date;
    recurringEndDateTime?: Date | undefined;
}

export enum ScheduleResourceType {
    Playlist = "Playlist",
    Image = "Image",
    Video = "Video",
}

export class ServerResponseOfListOfPlaylistScheduleDto extends ServerResponse implements IServerResponseOfListOfPlaylistScheduleDto {
    data?: PlaylistScheduleDto[];

    constructor(data?: IServerResponseOfListOfPlaylistScheduleDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(PlaylistScheduleDto.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): ServerResponseOfListOfPlaylistScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfListOfPlaylistScheduleDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfListOfPlaylistScheduleDto extends IServerResponse {
    data?: PlaylistScheduleDto[];
}

export class PlaylistScheduleDto implements IPlaylistScheduleDto {
    id?: string;
    canvasName?: string;
    startDate?: Date;
    endDate?: Date;
    recurringType?: RecurringType;

    constructor(data?: IPlaylistScheduleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.canvasName = _data["canvasName"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.recurringType = _data["recurringType"];
        }
    }

    static fromJS(data: any): PlaylistScheduleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaylistScheduleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["canvasName"] = this.canvasName;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["recurringType"] = this.recurringType;
        return data;
    }
}

export interface IPlaylistScheduleDto {
    id?: string;
    canvasName?: string;
    startDate?: Date;
    endDate?: Date;
    recurringType?: RecurringType;
}

export class CreateUserDto implements ICreateUserDto {
    email?: string;
    canManage?: boolean;
    canEditContent?: boolean;
    canViewContent?: boolean;
    canUploadContent?: boolean;

    constructor(data?: ICreateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.canManage = _data["canManage"];
            this.canEditContent = _data["canEditContent"];
            this.canViewContent = _data["canViewContent"];
            this.canUploadContent = _data["canUploadContent"];
        }
    }

    static fromJS(data: any): CreateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["canManage"] = this.canManage;
        data["canEditContent"] = this.canEditContent;
        data["canViewContent"] = this.canViewContent;
        data["canUploadContent"] = this.canUploadContent;
        return data;
    }
}

export interface ICreateUserDto {
    email?: string;
    canManage?: boolean;
    canEditContent?: boolean;
    canViewContent?: boolean;
    canUploadContent?: boolean;
}

export class UpdateUserDto implements IUpdateUserDto {
    email?: string;
    canManage?: boolean;
    canEditContent?: boolean;
    canViewContent?: boolean;
    canUploadContent?: boolean;

    constructor(data?: IUpdateUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.canManage = _data["canManage"];
            this.canEditContent = _data["canEditContent"];
            this.canViewContent = _data["canViewContent"];
            this.canUploadContent = _data["canUploadContent"];
        }
    }

    static fromJS(data: any): UpdateUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["canManage"] = this.canManage;
        data["canEditContent"] = this.canEditContent;
        data["canViewContent"] = this.canViewContent;
        data["canUploadContent"] = this.canUploadContent;
        return data;
    }
}

export interface IUpdateUserDto {
    email?: string;
    canManage?: boolean;
    canEditContent?: boolean;
    canViewContent?: boolean;
    canUploadContent?: boolean;
}

export class ServerResponseOfUserInfoListDto extends ServerResponse implements IServerResponseOfUserInfoListDto {
    data?: UserInfoListDto;

    constructor(data?: IServerResponseOfUserInfoListDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"] ? UserInfoListDto.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static override fromJS(data: any): ServerResponseOfUserInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServerResponseOfUserInfoListDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IServerResponseOfUserInfoListDto extends IServerResponse {
    data?: UserInfoListDto;
}

export class UserInfoListDto implements IUserInfoListDto {
    customerId?: string | undefined;
    dateCreated?: Date;
    firstName?: string;
    lastName?: string;
    email?: string;
    status?: UserStatus;
    userCustomerStatus?: UserCustomerStatus | undefined;
    hasSingleCustomer?: boolean;
    isAdminRole?: boolean;
    canManage?: boolean;
    canEditContent?: boolean;
    canViewContent?: boolean;
    canUploadContent?: boolean;
    companyName?: string | undefined;
    timeZoneInfo?: CustomerTimeZoneDto | undefined;
    totalFileSizedUsed?: number;
    storageLimit?: number | undefined;
    allowedCanvasesCount?: number | undefined;
    canvasesCount?: number | undefined;
    lastLoginAt?: Date | undefined;

    constructor(data?: IUserInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.dateCreated = _data["dateCreated"] ? new Date(_data["dateCreated"].toString()) : <any>undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.status = _data["status"];
            this.userCustomerStatus = _data["userCustomerStatus"];
            this.hasSingleCustomer = _data["hasSingleCustomer"];
            this.isAdminRole = _data["isAdminRole"];
            this.canManage = _data["canManage"];
            this.canEditContent = _data["canEditContent"];
            this.canViewContent = _data["canViewContent"];
            this.canUploadContent = _data["canUploadContent"];
            this.companyName = _data["companyName"];
            this.timeZoneInfo = _data["timeZoneInfo"] ? CustomerTimeZoneDto.fromJS(_data["timeZoneInfo"]) : <any>undefined;
            this.totalFileSizedUsed = _data["totalFileSizedUsed"];
            this.storageLimit = _data["storageLimit"];
            this.allowedCanvasesCount = _data["allowedCanvasesCount"];
            this.canvasesCount = _data["canvasesCount"];
            this.lastLoginAt = _data["lastLoginAt"] ? new Date(_data["lastLoginAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): UserInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["dateCreated"] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["status"] = this.status;
        data["userCustomerStatus"] = this.userCustomerStatus;
        data["hasSingleCustomer"] = this.hasSingleCustomer;
        data["isAdminRole"] = this.isAdminRole;
        data["canManage"] = this.canManage;
        data["canEditContent"] = this.canEditContent;
        data["canViewContent"] = this.canViewContent;
        data["canUploadContent"] = this.canUploadContent;
        data["companyName"] = this.companyName;
        data["timeZoneInfo"] = this.timeZoneInfo ? this.timeZoneInfo.toJSON() : <any>undefined;
        data["totalFileSizedUsed"] = this.totalFileSizedUsed;
        data["storageLimit"] = this.storageLimit;
        data["allowedCanvasesCount"] = this.allowedCanvasesCount;
        data["canvasesCount"] = this.canvasesCount;
        data["lastLoginAt"] = this.lastLoginAt ? this.lastLoginAt.toISOString() : <any>undefined;
        return data;
    }
}

export interface IUserInfoListDto {
    customerId?: string | undefined;
    dateCreated?: Date;
    firstName?: string;
    lastName?: string;
    email?: string;
    status?: UserStatus;
    userCustomerStatus?: UserCustomerStatus | undefined;
    hasSingleCustomer?: boolean;
    isAdminRole?: boolean;
    canManage?: boolean;
    canEditContent?: boolean;
    canViewContent?: boolean;
    canUploadContent?: boolean;
    companyName?: string | undefined;
    timeZoneInfo?: CustomerTimeZoneDto | undefined;
    totalFileSizedUsed?: number;
    storageLimit?: number | undefined;
    allowedCanvasesCount?: number | undefined;
    canvasesCount?: number | undefined;
    lastLoginAt?: Date | undefined;
}

export enum UserStatus {
    Active = "Active",
    Archived = "Archived",
    Pending = "Pending",
    Deleted = "Deleted",
}

export enum UserCustomerStatus {
    Pending = "Pending",
    Active = "Active",
    Archived = "Archived",
    Deleted = "Deleted",
}

export class AcceptInvitationDto implements IAcceptInvitationDto {
    customerId?: string;
    email?: string;
    token?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;

    constructor(data?: IAcceptInvitationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.email = _data["email"];
            this.token = _data["token"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.password = _data["password"];
            this.confirmationPassword = _data["confirmationPassword"];
        }
    }

    static fromJS(data: any): AcceptInvitationDto {
        data = typeof data === 'object' ? data : {};
        let result = new AcceptInvitationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["email"] = this.email;
        data["token"] = this.token;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["password"] = this.password;
        data["confirmationPassword"] = this.confirmationPassword;
        return data;
    }
}

export interface IAcceptInvitationDto {
    customerId?: string;
    email?: string;
    token?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    password?: string | undefined;
    confirmationPassword?: string | undefined;
}

export class UpdateUserProfileDto implements IUpdateUserProfileDto {
    customerId?: string | undefined;
    email?: string;
    firstName?: string;
    lastName?: string;
    oldPassword?: string;
    newPassword?: string;
    confirmPassword?: string;

    constructor(data?: IUpdateUserProfileDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.email = _data["email"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): UpdateUserProfileDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserProfileDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["email"] = this.email;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IUpdateUserProfileDto {
    customerId?: string | undefined;
    email?: string;
    firstName?: string;
    lastName?: string;
    oldPassword?: string;
    newPassword?: string;
    confirmPassword?: string;
}

export class PagedServerResponseOfUserInfoListDto implements IPagedServerResponseOfUserInfoListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: UserInfoListDto[];

    constructor(data?: IPagedServerResponseOfUserInfoListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UserInfoListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfUserInfoListDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfUserInfoListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfUserInfoListDto {
    pageCount?: number;
    pageNumber?: number;
    data?: UserInfoListDto[];
}

export class RequestResetPasswordDto implements IRequestResetPasswordDto {
    email?: string;

    constructor(data?: IRequestResetPasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): RequestResetPasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResetPasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IRequestResetPasswordDto {
    email?: string;
}

export class UpdatePasswordWithTokenDto implements IUpdatePasswordWithTokenDto {
    email?: string;
    token?: string;
    newPassword?: string;
    confirmPassword?: string;

    constructor(data?: IUpdatePasswordWithTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.token = _data["token"];
            this.newPassword = _data["newPassword"];
            this.confirmPassword = _data["confirmPassword"];
        }
    }

    static fromJS(data: any): UpdatePasswordWithTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePasswordWithTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["token"] = this.token;
        data["newPassword"] = this.newPassword;
        data["confirmPassword"] = this.confirmPassword;
        return data;
    }
}

export interface IUpdatePasswordWithTokenDto {
    email?: string;
    token?: string;
    newPassword?: string;
    confirmPassword?: string;
}

export class PagedServerResponseOfWindowsReleaseVersionDto implements IPagedServerResponseOfWindowsReleaseVersionDto {
    pageCount?: number;
    pageNumber?: number;
    data?: WindowsReleaseVersionDto[];

    constructor(data?: IPagedServerResponseOfWindowsReleaseVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageCount = _data["pageCount"];
            this.pageNumber = _data["pageNumber"];
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(WindowsReleaseVersionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PagedServerResponseOfWindowsReleaseVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedServerResponseOfWindowsReleaseVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageCount"] = this.pageCount;
        data["pageNumber"] = this.pageNumber;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPagedServerResponseOfWindowsReleaseVersionDto {
    pageCount?: number;
    pageNumber?: number;
    data?: WindowsReleaseVersionDto[];
}

export class WindowsReleaseVersionDto implements IWindowsReleaseVersionDto {
    appName?: string;
    blobName?: string;
    version?: string;
    releaseDate?: Date | undefined;
    releaseNote?: string;
    requirement?: string;

    constructor(data?: IWindowsReleaseVersionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appName = _data["appName"];
            this.blobName = _data["blobName"];
            this.version = _data["version"];
            this.releaseDate = _data["releaseDate"] ? new Date(_data["releaseDate"].toString()) : <any>undefined;
            this.releaseNote = _data["releaseNote"];
            this.requirement = _data["requirement"];
        }
    }

    static fromJS(data: any): WindowsReleaseVersionDto {
        data = typeof data === 'object' ? data : {};
        let result = new WindowsReleaseVersionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appName"] = this.appName;
        data["blobName"] = this.blobName;
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : <any>undefined;
        data["releaseNote"] = this.releaseNote;
        data["requirement"] = this.requirement;
        return data;
    }
}

export interface IWindowsReleaseVersionDto {
    appName?: string;
    blobName?: string;
    version?: string;
    releaseDate?: Date | undefined;
    releaseNote?: string;
    requirement?: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}